import * as ActionsTypes from "../../../../common/constants/stateConstants";

/*---------------------------------------------LOGIN-------------------------------------------------*/
export const loginAction = (payload) => {
  return {
    type: ActionsTypes.LOGIN,
    payload,

  };
};

export const loginSuccessAction = (token = null, qrCodeUrl = null, secret = null, otpData = null) => ({
    type: ActionsTypes.LOGIN_SUCCESS,
    token,      
    qrCodeUrl,  
    secret,     
    otpData,    
});

export const loginFailAction = (payload) => {
  return {
    type: ActionsTypes.LOGIN_FAIL,
    payload,
  };
};

/*---------------------------------------------LOGOUT-------------------------------------------------*/
export const logoutAction = () => {
  return {
    type: ActionsTypes.LOGOUT,
  };
};
export const logoutReinitalizationAction = () => {
  return {
    type: ActionsTypes.LOGOUT_REINITIALIZATION,
  };
};

export const registerMFA = (payload) => ({
    type: ActionsTypes.REGISTER_MFA,
    payload,
});

export const registerMFASuccess = (data) => {
  return {
    type: ActionsTypes.REGISTER_MFA_SUCCESS,
    data,
  };
};
export const registerMFAFailure = (error) => {
  return {
    type: ActionsTypes.REGISTER_MFA_FAILURE,
    error,
  };
};

export const sendOtpMail = (payload) => {
  return {
    type: ActionsTypes.SEND_OTP_MAIL,
    payload,
  };
};

export const sendOtpMailSuccess = (data) => {
  return {
    type: ActionsTypes.SEND_OTP_MAIL_SUCCESS,
    data,
  };
};

export const sendOtpMailFailure = (error) => {
  return {
    type: ActionsTypes.SEND_OTP_MAIL_FAILURE,
    error,
  };
};

